import { HttpClient } from '../api/client'
import { TokenManager } from '../auth/tokenManager'
import type { ApiResponse } from '@bandos/shared'

export interface SubscriptionInfo {
  status: string
  currentPeriodEnd: string | null
  cancelAtPeriodEnd: boolean
  priceId: string | null
}

export interface Invoice {
  id: string
  amount: number
  currency: string
  status: string
  created: number
  invoiceUrl: string | null
  pdfUrl: string | null
}

export interface CheckoutSessionResponse {
  sessionId: string
  url: string
}

export interface PortalSessionResponse {
  url: string
}

export class PaymentService {
  /**
   * Create a Stripe Checkout session for upgrade
   */
  static async createCheckoutSession(
    promoCode?: string
  ): Promise<ApiResponse<CheckoutSessionResponse>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.post<CheckoutSessionResponse>(
      '/payments/checkout',
      promoCode ? { promoCode } : {},
      headers
    )
  }

  /**
   * Create a Customer Portal session for subscription management
   */
  static async createPortalSession(): Promise<ApiResponse<PortalSessionResponse>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.post<PortalSessionResponse>('/payments/portal', {}, headers)
  }

  /**
   * Get current subscription info
   */
  static async getSubscription(): Promise<ApiResponse<{ subscription: SubscriptionInfo | null }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.get<{ subscription: SubscriptionInfo | null }>(
      '/payments/subscription',
      headers
    )
  }

  /**
   * Get invoice history
   */
  static async getInvoices(): Promise<ApiResponse<{ invoices: Invoice[] }>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.get<{ invoices: Invoice[] }>('/payments/invoices', headers)
  }
}
